import type { ComplianceFileStatus } from '@/shared/hooks/api/rohsComplianceFiles'

export type ComponentRohsProgressStatus =
  | 'none'
  | 'waiting'
  | 'notStarted'
  | 'inProgress'
  | 'completed'

export type ComponentRohsProgressInput = {
  rohsFile: {
    status: ComplianceFileStatus
    completedAt: string | null
    filledSlotCount: number
  } | null
}

export function resolveComponentRohsProgressStatus(
  input: ComponentRohsProgressInput
): ComponentRohsProgressStatus {
  if (input.rohsFile == null) {
    return 'none'
  }
  if (input.rohsFile.status === 'IDLE') {
    return 'waiting'
  }
  if (input.rohsFile.completedAt != null) {
    return 'completed'
  }
  if (input.rohsFile.filledSlotCount > 0) {
    return 'inProgress'
  }
  return 'notStarted'
}

export function componentRohsProgressShowsBadge(
  status: ComponentRohsProgressStatus
): boolean {
  return status !== 'none'
}
